import WebPerformanceIcon from "../assets/service/svg/services/web-performance.svg";
import PerformanceIcon from "../assets/service/svg/services/performanceTesting.svg";
import CertificateIcon from "../assets/service/svg/services/certificate.svg";
import SOSIcon from "../assets/service/svg/services/sos.svg";
import Location1Icon from "../assets/service/svg/services/location (1).svg";
import MediaTestingIcon from "../assets/service/svg/services/mediaTesting.svg";
import HmiTestingIcon from "../assets/service/svg/services/hmiTesting.svg";
import ApiIcon from "../assets/service/svg/services/api.svg";
import AppDevelopmentIcon from "../assets/service/svg/services/app-development.svg";
import PageSpeedIcon from "../assets/service/svg/services/page-speed 1.svg";
import AutomationIcon from "../assets/service/svg/services/automationTesting.svg";
import PerformanceTestingIcon from "../assets/service/svg/services/performanceTesting.svg";
import ApiTestingIcon from "../assets/service/svg/services/testing.svg";

import FieldTowerImage from "../assets/service/images/FieldTower.png";
import BuildingImage from "../assets/service/images/serviceBuildings.png";

// ========================================Telecommunication========================================

//Field Ferformance Testing Images
import FieldPermormanceTestingMainBanner from "../assets/service/images/Telecommunication/Field Performance Setting/FieldPermormanceTestingMainBanner.jpg";
import FieldPermormanceTestingBannerImg from "../assets/service/images/Telecommunication/Field Performance Setting/fieldPerformanceBannerImage.jpg";
import FieldPermormanceTestingTitleImg from "../assets/service/images/Telecommunication/Field Performance Setting/fieldPerformanceTitleImage.png";
//Field Ferformance Testing Tags
import MobilityTestingIcon from "../assets/service/svg/tags/Field Performance Testing/Mobility Testing.svg";
import StationaryTestingIcon from "../assets/service/svg/tags/Field Performance Testing/Stationary Testing.svg";
import WalkTestIcon from "../assets/service/svg/tags/Field Performance Testing/Walk Test.svg";

//Global Certification Forum Images
import GlobalCertificationForumMainBanner from "../assets/service/images/Telecommunication/Global Certification Forum/mainBannerImg.jpg";
import GlobalCertificationForumTitleImg from "../assets/service/images/Telecommunication/Global Certification Forum/titleImg.jpg";
import GlobalCertificationForumBanner from "../assets/service/images/Telecommunication/Global Certification Forum/bannerImg.png";
//Global Certification Forum Tags
import CertificationAssistanceIcon from "../assets/service/svg/tags/Global Certification Forum(GCF)/Certification Assistance.svg";
import ComprehensiveDeviceCoverageIcon from "../assets/service/svg/tags/Global Certification Forum(GCF)/Comprehensive Device Coverage.svg";
import DeviceCertificationFrameworkIcon from "../assets/service/svg/tags/Global Certification Forum(GCF)/Device Certification Framework.svg";
import FieldandInteroperabilityTestingIcon from "../assets/service/svg/tags/Global Certification Forum(GCF)/Field and Interoperability Testing.svg";
import NetworkOperatorAssuranceIcon from "../assets/service/svg/tags/Global Certification Forum(GCF)/Network Operator Assurance.svg";

//Network Benchmark Testing Images
import NetworkBenchmarkTestingMainBanner from "../assets/service/images/Telecommunication/Network Benchmark Testing/mainBannerImg.jpg";

//Network Benchmark Testing Tags
import ComparativeAnalysisIcon from "../assets/service/svg/tags/Network Benchmarking/Comparative Analysis.svg";
import CoverageTestingIcon from "../assets/service/svg/tags/Network Benchmarking/Coverage Testing.svg";
import LatencyTestingIcon from "../assets/service/svg/tags/Network Benchmarking/Latency Testing.svg";
import PerformanceBenchmarkingIcon from "../assets/service/svg/tags/Network Benchmarking/Performance Benchmarking.svg";
import QualityofServiceQoSTestingIcon from "../assets/service/svg/tags/Network Benchmarking/Quality of Service (QoS) Testing.svg";
import ThroughputTestingIcon from "../assets/service/svg/tags/Network Benchmarking/Throughput Testing.svg";

//SOS Call Testing Images
import SOSCallTestingMainBanner from "../assets/service/images/Telecommunication/SoS Calls Testing/mainBannerImg.jpg";
import SOSCallTestingBanner from "../assets/service/images/Telecommunication/SoS Calls Testing/bannerImg.jpg";
import SOSCallTestingTitle from "../assets/service/images/Telecommunication/SoS Calls Testing/titleImg.jpg";
// SOS Call Testing Icons
import ComplianceTestingIcon from "../assets/service/svg/tags/SOS Call Testing/Compliance Testing.svg";
import FunctionalTestingIcon from "../assets/service/svg/tags/SOS Call Testing/Functional Testing.svg";
import PerformanceTestIcon from "../assets/service/svg/tags/SOS Call Testing/Performance Testing.svg";

// ========================================Infotainment Systems========================================
//GPS Testing Images
import GPSMainBanner from "../assets/service/images/Infotainment Systems/GPS Testing/mainBannerImg.jpg";
import GPSBanner from "../assets/service/images/Infotainment Systems/GPS Testing/bannerImg.jpg";
import GPSTitleImg from "../assets/service/images/Infotainment Systems/GPS Testing/titleImg.jpg";

//GPS Testing Tags
import EnvironmentalTestingIcon from "../assets/service/svg/tags/GPS Testing/Environmental Testing.svg";
import ErrorDetectionAndRectificationIcon from "../assets/service/svg/tags/GPS Testing/Error Detection and Rectification.svg";
import FeatureTestingIcon from "../assets/service/svg/tags/GPS Testing/Feature Testing.svg";
import ParameterEvaluationIcon from "../assets/service/svg/tags/GPS Testing/Parameter Evaluation.svg";
import SignalReceptionTestingIcon from "../assets/service/svg/tags/GPS Testing/Signal Reception Testing.svg";
import SystemIntegrationTestingIcon from "../assets/service/svg/tags/GPS Testing/System Integration Testing.svg";

//Tuner And Media Testing Images
import TunnerAndMediaMainBanner from "../assets/service/images/Infotainment Systems/Tuner And Media Testing/mainBannerImg.jpg";
import TunnerAndMediaTitleImg from "../assets/service/images/Infotainment Systems/Tuner And Media Testing/titleImg.jpg";
import TunnerAndMediaBanner from "../assets/service/images/Infotainment Systems/Tuner And Media Testing/banner.jpg";
//Tuner And Media Testing Tags
import AudioSystemTestingIcon from "../assets/service/svg/tags/Tuner and Media Testing/Audio System Testing.svg";
import BroadcastStandardsTestingIcon from "../assets/service/svg/tags/Tuner and Media Testing/Broadcast Standards Testing.svg";
import ConnectivityandNetworkTestingIcon from "../assets/service/svg/tags/Tuner and Media Testing/Connectivity and Network Testing.svg";

//HMI Testing Images
import HMIMainBanner from "../assets/service/images/Infotainment Systems/HMI Testing/mainBanner.jpg";
import HMIBanner from "../assets/service/images/Infotainment Systems/HMI Testing/bannerImg.jpg";
import HMITitleImg from "../assets/service/images/Infotainment Systems/HMI Testing/titleImg.jpg";
//HMI Testing Tags
import FunctionalityTestingIcon from "../assets/service/svg/tags/HMI Testing/Functionality Testing.svg";
import IntegrationTestingIcon from "../assets/service/svg/tags/HMI Testing/Integration Testing.svg";
import LocalizationTestingIcon from "../assets/service/svg/tags/HMI Testing/Localization Testing.svg";
import PerformanceOptimizationIcon from "../assets/service/svg/tags/HMI Testing/Performance Optimization.svg";
import SafetyAndComplianceTestingIcon from "../assets/service/svg/tags/HMI Testing/Safety and Compliance Testing.svg";
import UsabilityAndUserExperienceIcon from "../assets/service/svg/tags/HMI Testing/Usability and User Experience.svg";
// ========================================Software Development========================================
//Mobile APP development Images
import MobileAppDevMainBanner from "../assets/service/images/Software Development/Mobile App Development/mainBannerImg.jpg";
import MobileAppDevBanner from "../assets/service/images/Software Development/Mobile App Development/bannerImg.jpg";
import MobileAppDevTitleImg from "../assets/service/images/Software Development/Mobile App Development/titleImg.jpg";

import AndroidAppsIcon from "../assets/service/svg/tags/Mobile Apps Development/Android Apps.svg";
import CrossPlatformAppsIcon from "../assets/service/svg/tags/Mobile Apps Development/Cross Platform Apps.svg";
import IosappIcon from "../assets/service/svg/tags/Mobile Apps Development/Ios app.svg";

//Web Apps Development TestingImages
import WebAppsDevelopmentTestingMainBanner from "../assets/service/images/Software Development/Web Development/mainBanner.jpg";
import WebAppsDevelopmentTestingBanner from "../assets/service/images/Software Development/Web Development/bannerImg.jpg";
import WebAppsDevelopmentTestingTitle from "../assets/service/images/Software Development/Web Development/titleImg.jpg";
//Web Apps Development Testing
import CustomWebDevelopmentIcon from "../assets/service/svg/tags/Web Apps Development/Custom Web Development.svg";
import FullStackWebDevelopmentIcon from "../assets/service/svg/tags/Web Apps Development/Full Stack Web Development.svg";
import ProgressiveWebDevelopmentIcon from "../assets/service/svg/tags/Web Apps Development/Progressive Web Development.svg";

// ========================================Quality Assurance========================================
//Api Testing Images
import ApiTestingMainBannerImg from "../assets/service/images/Quality Assurance/API Testing/mainBannerImg.jpg";
import ApiTestingTitleImg from "../assets/service/images/Quality Assurance/API Testing/titleImg.jpg";
import ApiTestingBannerImg from "../assets/service/images/Quality Assurance/API Testing/bannerImg.jpg";
//Api Testing tags
import ApiTestingAutomationIcon from "../assets/service/svg/tags/API Testing/API Testing Automation.svg";
import FunctionalTestIcon from "../assets/service/svg/tags/API Testing/Functional Testing.svg";
import SecurityTestingIcon from "../assets/service/svg/tags/API Testing/Security Testing.svg";

//Automation Testing Images
import AutomationTestingMainBannerImg from "../assets/service/images/Quality Assurance/Automation Testing/mainBannerImg.jpg";
import AutomationTestingTitleImg from "../assets/service/images/Quality Assurance/Automation Testing/titleImg.jpg";
import AutomationTestingBannerImg from "../assets/service/images/Quality Assurance/Automation Testing/bannerImg.jpg";
//Automation Testing tags
import CrossBrowserTestingAutomationIcon from "../assets/service/svg/tags/Automation Testing/Cross-Browser Testing Automation.svg";
import MobileApplicationTestingAutomationIcon from "../assets/service/svg/tags/Automation Testing/Mobile Application Testing Automation.svg";
import PerformanceAndLoadTestingAutomationIcon from "../assets/service/svg/tags/Automation Testing/Performance and Load Testing Automation.svg";

//Manual Testing Images
import ManualTestingMainBannerImg from "../assets/service/images/Quality Assurance/Manual Testing/mainBanner.jpg";
import ManualTestingTitleImg from "../assets/service/images/Quality Assurance/Manual Testing/titleImg.jpg";
import ManualTestingBannerImg from "../assets/service/images/Quality Assurance/Manual Testing/bannerImg.jpg";
//Manual Testing tags
import FunctionalIcon from "../assets/service/svg/tags/Manual Testing/Functional Testing.svg";
import RegressionTestingIcon from "../assets/service/svg/tags/Manual Testing/Regression Testing.svg";
import UsabilityTestingIcon from "../assets/service/svg/tags/Manual Testing/Usability Testing.svg";

// Performance Testing Images
import PerformanceTestingMainBannerImg from "../assets/service/images/Quality Assurance/Performance Testing/mainBanner.jpg";
import PerformanceTestingTitleImg from "../assets/service/images/Quality Assurance/Performance Testing/titleImg.jpg";
import PerformanceTestingBannerImg from "../assets/service/images/Quality Assurance/Performance Testing/bannerImg.jpg";
// Performance Testing Tags

// the following object is used to store the information of the main services on of
// Vis group on the services Page. it does not include the detail page.
//once the user clicks on the service it will take the user to the detial page.

// Tags and sub service areas data for the content mentioned on the services
// detail page.

// the new and updated object starts from Here the above code will be discared

// here the short details of the services on the services page,

export const servicesCategory = [
  {
    uuid: 1,
    name: "Telecommunication",
    child: [
      {
        uuid: 1,
        label: "Network Benchmark Testing",
        href: "networkBenchmarkTesting",
        icon: WebPerformanceIcon,
        title: "Network Benchmark Testing",
        discription: `Unleash the power of your network with Vis Group 
          comprehensive Network Benchmark Testing services. Our multi-dimensional
            testing services provide in-depth analysis and insights,
            ensuring optimal performance and reliability.
            `,
      },
      {
        uuid: 2,
        label: "Field Performance Testing",
        href: "fieldPerformanceTesting",
        icon: PerformanceIcon,
        title: "Field Performance Testing",
        discription: `Improve and enhance your network, service quality,
           and operations with our Field Performance Testing Services.
            Our thorough testing provides detailed insights and
            actionable recommendations to optimize performance.
             `,
      },
      {
        uuid: 3,
        label: "Global Certification Forum",
        href: "globalCertificationTesting",
        icon: CertificateIcon,
        title: "Global Certification Forum",
        discription: `Gain international certifications and recognition
           for your organization and workflows with the assistance
            and guidance of industry experts from Vis Group.
            Our experienced team ensures you meet global standards, enhancing your credibility
             and competitive edge.`,
      },
      {
        uuid: 4,
        label: "SoS Calls Testing",
        href: "sosCallsTesting",
        icon: SOSIcon,
        title: "SoS Calls Testing",
        discription: `Our SOS Emergency Calls Testing and Verification Service
         ensures the reliability and accuracy of emergency call systems.
          Through rigorous testing and thorough verification processes,
           we makes sure that your SOS functionality operates
           flawlessly under varying conditions.`,
      },
    ],
  },

  {
    uuid: 2,
    name: "Infotainment Systems",
    child: [
      {
        uuid: 5,
        label: "GPS Testing",
        href: "gpsTesting",
        icon: Location1Icon,
        title: "GPS Testing",
        discription: `Enhance, test, and improve your GPS-related services to
           meet and exceed your customers' requirements and needs.
           Our comprehensive solutions ensure optimal performance,
            accuracy, and reliability, delivering exceptional
            user experiences and satisfaction.`,
      },
      {
        uuid: 6,
        label: "Tuner And Media Testing",
        href: "tunerAndMediaTesting",
        icon: MediaTestingIcon,
        title: "Tuner And Media Testing",
        discription: `To ensure the correct functionality of each part of the
           infotainment system and to discover sources and effects of interference,
           we offer a complete set of test and measurement solutions for multimedia,
            audio, antennas, and navigation services.`,
      },
      {
        uuid: 7,
        label: "HMI Testing",
        href: "hmiTesting",
        icon: HmiTestingIcon,
        title: "HMI Testing",
        discription: `Test and evaluate the complex and challenging aspects
           of human and machine interaction for your digital solutions with
          Vis Group. Our comprehensive evaluations ensure
            seamless integration and optimal performance,
             enhancing user experience and satisfaction`,
      },
    ],
  },
  {
    uuid: 3,
    name: "Software Development",
    child: [
      {
        uuid: 8,
        label: "Web  Development",
        href: "webAppDev",
        icon: ApiIcon,
        title: "Web Development",
        discription: `We Develop dynamic, high-performance web applications tailored 
          to your specific needs. We focus on delivering user-friendly, scalable,
          and secure solutions that enhance user experience and drive business growth.
          Rely on our expertise to turn your web app vision
           into reality with precision and excellence`,
      },
      {
        uuid: 9,
        icon: AppDevelopmentIcon,
        label: "Mobile App Development",
        href: "mobileAppDev",
        title: "Mobile App Development",
        discription: `Our Mobile Apps Development service delivers innovative,
           high-quality mobile solutions tailored to your needs.
           We specialize in creating user-friendly, feature-rich apps
            that enhance user experience and drive engagement.
             Trust our expertise to bring your mobile app
              vision to life with precision and excellence`,
      },
    ],
  },
  {
    uuid: 4,
    name: "Quality Assurance",
    child: [
      {
        uuid: 10,
        label: "Manual Testing",
        href: "manualTesting",
        icon: PageSpeedIcon,
        title: "Manual Testing",
        discription: `Test and validate your critical software solutions with
           Vis Group's experienced and dedicated team of test engineers and test
           managers. Our expertise ensures thorough evaluations and reliable
           performance, guaranteeing the highest quality for your software.`,
      },
      {
        uuid: 11,
        label: "Automation Testing",
        href: "automationTesting",
        icon: AutomationIcon,
        title: "Automation Testing",
        discription: `Explore and implement effective automated quality
           assurance and testing services with Vis Group.
           Our advanced solutions ensure accuracy, efficiency,
           and reliability, optimizing your
            system performance and quality.`,
      },
      {
        uuid: 12,
        label: "Performance Testing",
        href: "performanceTesting",
        icon: PerformanceTestingIcon,
        title: "Performance Testing",
        discription: `Our System Performance Testing service ensures your
           systems run efficiently and reliably. We conduct thorough
            evaluations to identify and resolve potential issues,
             optimizing performance for seamless operation
             and enhanced user satisfaction.`,
      },
      {
        uuid: 13,
        label: "API Testing",
        href: "apiTesting",
        icon: ApiTestingIcon,
        title: "API Testing",
        discription: `Discover and implement cutting-edge API testing services 
          with Vis Group. Our comprehensive approach ensures your APIs are accurate,
           efficient, and reliable, enhancing performance and quality. `,
      },
    ],
  },
];

export const serviceDetail = [
  // service detail page content for network benchmark testing
  {
    serviceId: 1,
    label: "your Network Benchmark is Our Passion",
    title: "Network Benchmark Testing",
    titleImg: FieldTowerImage,
    subtitle: "Benchmark Your Network to Superior Performance",
    titleDiscription:
      "Every mobile network operator throughout the world invests a huge amount of resources in terms of time and cost to improve and enhance their service quality. Network benchmarking helps network providers, to evaluate their network performance against their competitors in the market. With a constant demand for new services and better network performance, it is critical that operators have a reliable, accurate, and reproducible way to measure the services provided to their customers and compare themselves against other operators. Our comprehensive benchmarking reports can be used to analyze their performance, identify their weakness, and take measurements to improve furthermore.",
    bannerImg: BuildingImage,
    mainBanner: NetworkBenchmarkTestingMainBanner,
    bannerTitle: "Unveiling Network Strengths, One Test at a Time.",
    bannerDiscriptions: [
      `Network benchmarking is a fundamental necessity for telecom regulators and operators.
       Regulators have to conduct drive testing in order to monitor the quality of service
        standards against the KPIs agreed on with the operators, and operators undergo
        benchmarking activity to do exhaustive analysis, to remain competitive. It is
        also an effective way of getting to know the competition and gathering valuable
        information as a source for focused promotional campaigns.We offer among other
         services, a complete set of network benchmarking services through Field-Testing
          (Drive and Walk Tests). Drive test is performed in cities, towns, and on roads,
           while walk test is performed in public areas like airports, shopping malls, etc.
           `,

      ` For every area, we have weighted scores which will be added to calculate
             the total score for each operator. As per customer requirements, key
              performance indicators (KPIs) are decided within the project scope,
               which determines the team configuration and size. To achieve the
               desired results and to identify the loopholes in the service quality
               our Professionals Field Engineers collect the data, which is then analyzed
               by our radio network experts and presented to the customer in the form of
               reports against their KPIs.We have successfully performed different
                drive and walk tests campaigns for various clients in the whole EU,
                 in countries such as Germany, the Netherlands, Sweden, Italy, France,
                  the UK, UAE, Kuwait, the Kingdom of Saudi Arabia, Qatar, and many more.
                   We use the latest mobile devices, high-end drive test tools,
                   and RF scanners for measurements around the globe.`,
    ],
  },

  // service detail page content for field performance testing
  {
    serviceId: 2,
    label: "Optimizing Networks, Enhancing Performance",
    title: "Field Performance Testing",
    titleImg: FieldPermormanceTestingTitleImg,
    subtitle:
      "Field Performance Testing Your Path to Superior Network Performance",
    titleDiscription: `Every mobile network operator throughout the world invests a huge amount of resources
       in terms of time and cost to improve and enhance their service quality. Network
       benchmarking helps network providers, to evaluate their network performance against
        their competitors in the market. With a constant demand for new services and better
         network performance, it is critical that operators have a reliable, accurate,
          and reproducible way to measure the services provided to their customers and
           compare themselves against other operators. Our comprehensive benchmarking
            reports can be used to analyze their performance, identify their weakness,
             and take measurements to improve furthermore.`,
    bannerImg: FieldPermormanceTestingBannerImg,
    mainBanner: FieldPermormanceTestingMainBanner,
    bannerTitle: "Driving Excellence in Telecom Network Field Performance",
    bannerDiscriptions: [
      `Field Performance Testing is a fundamental necessity for telecom regulators and operators.
       Regulators have to conduct drive testing in order to monitor the quality of service standards
       against the KPIs agreed on with the operators, and operators undergo benchmarking activity
        to do exhaustive analysis, to remain competitive. It is also an effective way of
         getting to know the competition and gathering valuable information as a source
          for focused promotional campaigns.We offer among other services,
           a complete set of network benchmarking services through Field-Testing
           (Drive and Walk Tests). Drive test is performed in cities, towns, and on roads,
            while walk test is performed in public areas like airports, shopping malls, etc.
            For every area, we have weighted scores which will be added to calculate
             the total score for each operator. 
                `,

      `As per customer requirements,
              key performance indicators (KPIs) are decided within the project scope,
               which determines the team configuration and size. To achieve the desired
               results and to identify the loopholes in the service quality our Professionals
                Field Engineers collect the data, which is then analyzed by our radio network experts
                 and presented to the customer in the form of reports against their KPIs.
      We have successfully performed different drive and walk tests campaigns
      for various clients in the whole EU, in countries such as Germany, the
       Netherlands, Sweden, Italy, France, the UK, UAE, Kuwait, the Kingdom
        of Saudi Arabia, Qatar, and many more. We use the latest mobile devices,
         high-end drive test tools, and RF scanners for measurements around the globe.`,
    ],
  },

  // service detail page content for global Certification forum

  {
    serviceId: 3,
    label: "Your Path to Seemless Certifications",
    title: "Global Certification Forum(GCF)",
    titleImg: GlobalCertificationForumTitleImg,
    subtitle: "Unlock Market Access with Proven GCF Certification",
    titleDiscription: `Gain international certifications and recognition
           for your organization and workflows with the assistance
            and guidance of industry experts from Vis Group.
            Our experienced team ensures you meet global standards, enhancing your credibility
             and competitive edge.
             The basic intuition behind the GCF Certification is to provide
       a certified framework for devices with integrated cellular
       technologies such as GERAN (GSM), UTRAN (UMTS), and E-UTRAN (LTE),
        which work within the global frequency bands (GSM 900/1800,
        FDD I and FDD VIII). All devices with integrated 3GPP modules
        like netbooks, consumer electronic devices, smart meters, etc.,
        but also handsets, PDAs, smartphones, USB modules, and other
        components benefit from GCF Certification`,
    bannerImg: GlobalCertificationForumBanner,
    mainBanner: GlobalCertificationForumMainBanner,
    bannerTitle: "Global Standards, Guaranteed Performance",
    bannerDiscriptions: [
      `The basic intuition behind the GCF Certification is to provide
       a certified framework for devices with integrated cellular
       technologies such as GERAN (GSM), UTRAN (UMTS), and E-UTRAN (LTE),
        which work within the global frequency bands (GSM 900/1800,
        FDD I and FDD VIII). All devices with integrated 3GPP modules
        like netbooks, consumer electronic devices, smart meters, etc.,
        but also handsets, PDAs, smartphones, USB modules, and other
        components benefit from GCF Certification.`,
      `Mobile network operators focus on the tests which ensure that 
      new devices will work well in their networks. However, testing
       new devices for conformance and interoperability is hardly feasible.
        By relying on GCF Certification, operators can be sure that the core
         functionalities of a new device fulfill their requirements.
         GCF Certification is a plus for selling devices to operators or
         retailers, especially in Europe and Asia.`,

      `We assist manufacturers in the process of obtaining GCF Certification. 
      Along with our authorized partners, we develop test cases to cover the
      functionalities of a device and conduct Field Testing and Interoperability Testing.
      The results are documented and submitted for review to obtain the certification.`,
    ],
  },

  // service detail page content for SOS emergency calls testing

  {
    serviceId: 4,
    label: "Ensuring reliable SOS emergency call performance",
    title: "SoS Emergency Call Testing",
    titleImg: SOSCallTestingTitle,
    subtitle: "Delivering Reliable SOS Connectivity When It Matters Most",
    titleDiscription: `In critical moments, the reliability and functionality of SOS emergency calls 
      can be a matter of life and death. Our comprehensive SOS Emergency Calls Testing
       service ensures that emergency communication systems are robust, reliable, and
        ready to perform under any circumstances.Our SOS Emergency Calls Testing
         service is designed to rigorously test and validate the functionality, performance,
          and reliability of emergency call systems. We use state-of-the-art tools and
           methodologies to ensure that your emergency communication systems meet the
           highest standards of safety and efficiency`,
    bannerImg: SOSCallTestingBanner,
    mainBanner: SOSCallTestingMainBanner,
    bannerTitle: "Ensuring Lifesaving Communication Reliability and Efficiency",
    bannerDiscriptions: [
      `Our SOS Emergency Calls Testing service offers a comprehensive suite of features
       designed to ensure the highest levels of reliability and performance. We conduct
       end-to-end call testing to verify the entire call process, from initiation to
        connection, ensuring calls are routed correctly to emergency services. Voice
        quality assessment is performed to test the clarity and quality of voice communication,
        ensuring that emergency information is conveyed accurately. We also perform redundancy
         and failover testing to guarantee that backup systems activate seamlessly if
          the primary system fails, ensuring continuous service availability.`,
      `Performance testing includes load testing to simulate high call volumes 
      and assess the system’s ability to handle peak loads without performance
      degradation, as well as stress testing to push the system beyond normal
      operational capacity and identify breaking points. We measure response
      times to ensure calls are connected and responded to promptly by emergency
       services. Security testing involves vulnerability assessments to identify
       and address potential security risks, encryption verification to ensure
        communication is secure and protected from interception, and authentication
        testing to prevent unauthorized access to emergency services.`,
      `Compliance testing ensures the system adheres to local, national, and
       international regulations and standards, including accessibility testing to
        verify that the system is accessible to all users, including those with disabilities.
        Our comprehensive testing approach ensures that your SOS emergency call system meets
        the highest standards of functionality, performance, security, and compliance, providing
         peace of mind and reliable communication in critical moments.

`,
    ],
  },

  // service detail page content for GPS Testing

  {
    serviceId: 5,
    label: "your GPS Testing is Our Passion",
    title: "GPS Testing",
    titleImg: GPSTitleImg,
    subtitle: "Navigating Excellence: Ensuring GPS Accuracy and Performance",
    titleDiscription: `The global positioning system (GPS) is a space-based radio navigation system,
       And the use of GPS is increasing day by day. It’s important for manufacturers to
       make sure that GPS receivers get signals and communicate effectively with all the
        connected systems GPS navigation is a common feature in automobiles now.
        Drivers rely on this to find unfamiliar locations and find the route to reach
         that destination. Beyond this fundamental duty of the GPS navigator, present-day
         navigators provide many new features such as the alternative route to the same location,
          redirecting routes, routes avoiding tolls, ferries, other points of interest, etc.`,
    bannerImg: GPSBanner,
    mainBanner: GPSMainBanner,
    bannerTitle: "Excellence in GPS Testing for Reliable Navigation.",
    bannerDiscriptions: [
      `There are a series of fundamental receiver performance parameters applicable to GPS
       systems such as sensitivity, time to first fix and reacquisition time, etc.
       Our talented team of test engineers and test managers run test cases based on
        all these parameters to evaluate the performance of the GPS system and thus
         help the manufacturers to find out errors in their system and to rectify them,
          to provide customers a better experience.`,
    ],
  },

  // service detail page content for tuner and media testing
  {
    serviceId: 6,
    label: "your Tuner And Media Testing is Our Passion",
    title: "Tuner And Media Testing",
    titleImg: TunnerAndMediaTitleImg,
    subtitle: "Testing for Flawless Tuner and Media Functionality",
    titleDiscription: `Automotive infotainment is generally a hardware and software platform that delivers 
      audio and video in your car. This could be, for example, car radio broadcasting, audio,
       and video streaming via a wireless (LTE, Wi-Fi, Bluetooth®) or wired network (HDMI, Ethernet),
        or even a CD or USB device.
        Tuner & Media solutions in cars are becoming increasingly complex.
         Mobile internet, traffic information, navigation, digital broadcast,
          and streaming services are all combined in one system.
           Each service requires its antennas. To ensure the correct
            functionality of each part of the infotainment system and to
             discover sources and effects of interference,`,
    bannerImg: TunnerAndMediaBanner,
    mainBanner: TunnerAndMediaMainBanner,
    bannerTitle:
      "Testing Tuner and Media Systems for Seamless and High-Quality Entertainment",
    bannerDiscriptions: [
      `we offer a complete set of test and measurement solutions for multimedia,
       audio, antennas, and navigation services. With the vast number of available
        broadcast, wireless and cellular standards as well as different audio and video
         file formats and codecs, manufacturers of infotainment systems need to ensure
          the correct functionality, even in the presence of interference.`,
      `We Offer “Tuner & Media” Test Solutions For:All analog and digital broadcasting standards
       Compliance testing for the radio equipment directive (RED) for AM, FM, DAB, DRM, Wi-Fi,
       Bluetooth®, LTE, GNSS, radar, and much more, Conformance testing for HDMI interfaces
       and Ethernet (100BASE-T1 and 1000 BASE-T1),Audio speaker setup testing,
       Complex receiver diversity test scenarios (1x2, 1x3, and 1x4), Realistic
        generation of dynamic navigation scenarios and Production testing
         for infotainment systems (multichannel generator using radio,
         LTE, Wi-Fi, GNSS signals, etc).`,
    ],
  },

  // service detail page content for human machine interface testing
  {
    serviceId: 7,
    label: "Test and Evaluate your Product HMI Aspects",
    title: "HMI Testing",
    titleImg: HMITitleImg,
    subtitle: "Testing HMI Systems for Intuitive and Reliable Performance",
    titleDiscription: `Infotainment, HMI (human-machine interface), and connectivity encompass functions
       that allow the driver and passengers to interact with the vehicle's infotainment
        and user interface systems. HMIs deliver convenience, information, and entertainment
        in a safe and seamless manner. HMI is amongst the most readily-visible and highly-used
        functions in the vehicle.
These HMI and associated functionalities provide huge opportunities for unique branding
 and differentiation in the market and help in a competitive advantage for manufacturers.
 This includes traditional radio tuners on the low end to complex infotainment systems
  controlled through large touch panel displays.`,
    bannerImg: HMIBanner,
    mainBanner: HMIMainBanner,
    bannerTitle:
      "Comprehensive HMI Testing Procedures for Flawless Human Machine Interaction Interaction",
    bannerDiscriptions: [
      `Although the range of HMI functionalities is quite broad. However, 
      they share many common design challenges. We test HMI software systems
       to ensure that complex technical features are perfectly interlinked to each other,
        as well the interfacing between different applications is easy and smooth for drivers
         to perform actions. Also, we help the developers in the localization
          of HMI in different markets.`,
    ],
  },

  // service detail page content for Web Apps  Development
  {
    serviceId: 8,
    label: "Top Notch Web Application Development Services",
    title: "Web Development",
    titleImg: WebAppsDevelopmentTestingTitle,
    subtitle:
      "Creating Scalable and Secure Web Applications for Business Growth",
    titleDiscription: `Custom and on-Demand Software Development Services that Take Care of your Digital
       Transformation Needs We plan, code, test and deploy scalable and custom software
        solutions for start-ups, small and medium-sized businesses, and enterprise-level
         applications to empower them to unleash the potential of digital transformation.
          Our developers and engineers leverage agile practices to develop innovative &
          powerful web applications, high-level mobile applications, and any other custom
          applications to meet the specified requirements and market needs.`,
    bannerImg: WebAppsDevelopmentTestingBanner,
    mainBanner: WebAppsDevelopmentTestingMainBanner,
    bannerTitle: "Crafting Excellence in Every Line of Code",
    bannerDiscriptions: [
      `So, Hire us for your digital transformation adventure; we will make it a smooth ride for you.
      One of the most visible advantages of a custom solution is that it eliminates any further
      investments in the shape of commercial-of-the-shelf products. To stay relevant
       and keep your presence in a competitive environment, you need to keep
       looking for innovation and updates in your system. BX technology remodels
        and develops a legacy system to meet the varying demands of modern-day businesses.`,
      `Modern-day software solutions are highly efficient and robust;
       This efficiency comes due to API. Our dedicated team of software
        engineers has in-depth experience in API-driven development and API
        integration.Software as a Service(SaaS) applications is widely used
         worldwide due to several benefits, such as less downtime, reduced
          infrastructure costs, etc. We use our knowledge and experience
          to develop SaaS solutions within the deadline and budget.`,
    ],
  },

  // service detail page content for mobile apps  development
  {
    serviceId: 9,
    label: "your Mobile App Development is Our Passion",
    title: "Mobile App Development",
    titleImg: MobileAppDevTitleImg,
    subtitle:
      "Innovative Mobile Application Development Services that Meet User Expectations",
    titleDiscription: `Adopt a modern and state-of-the-art approach for your next mobile application development
 project with BX Technologies. A top-rated software development firm where the focus is on
 the multi-dimensional aspects of your project idea. We believe in and deliver a scalable,
  interactive, high-performance, and fully functional mobile application to our clients
   across the globe. Bx technologies have the expertise to undertake any project wither,
    developing an application from scratch or maintaining or improving new features
     in an existing mobile application. We are experts in ios, Android, cross-platform,
      and native mobile application development. We have expertise
      and experience on multiple technology stacks, development tools,
       and frameworks to implement your digital solution according to your
        business needs. Our development team would love to hear from you and
         work on turning your ideas into reality.`,
    bannerImg: MobileAppDevBanner,
    mainBanner: MobileAppDevMainBanner,
    bannerTitle:
      "Innovative Mobile Application Development Services that Meet User Expectations",
    bannerDiscriptions: [
      `We understand that each business has its own challenges and goals.
       Therefore, we offer custom mobile app development services that align
        perfectly with your business objectives. Whether you need a native app,
         hybrid app, or cross-platform solution, we leverage the latest
         technologies and development frameworks to deliver scalable
          and high-performance applications.
      User experience (UX) is at the core of our app development process.
       We focus on creating seamless and intuitive interfaces that enhance
        usability and keep users engaged. From wireframing and
        prototyping to UI design and development, we ensure every aspect
        of the app is meticulously crafted to
        deliver a superior user experience`,

      `We follow an agile methodology that emphasizes flexibility,
       transparency, and rapid iteration. This allows us to adapt to
        changing requirements, incorporate feedback early in the development
         cycle, and deliver solutions that meet evolving market demands.
         Our iterative approach ensures that you receive a functional and
         market-ready app within the stipulated time frame. 
    Partner with Vis Group to transform your mobile app idea into a reality
       that drives business growth, enhances customer engagement, and
       amplifies your digital presence in the competitive mobile landscape.
        Let us help you leverage the power of mobile technology to achieve
        your business goals effectively`,
    ],
  },

  // service detail page content for manual  testing
  {
    serviceId: 10,
    label: "your Manual Testing is Our Passion",
    title: "Manual Testing",
    titleImg: ManualTestingTitleImg,
    subtitle: "Human Insight for Comprehensive Software Quality Assurance",
    titleDiscription: `Manual testing is considered the backbone of the complete quality assurance and testing
       life cycle. It is impossible to guarantee a high quality of a product without manual
       testing procedures. Manual testing, as its name implies, is performed by a human.
       This type of software testing is the simplest one but helps to detect critical
       bugs and system vulnerabilities. It doesn't require knowledge of specific automated
        tools but a set of special skills and a thorough understanding of the project requirements.
         In other words, manual testing can be defined as a process of software testing performed
          from the end-user's perspective in order to detect existing defects and provide a high
           level of product quality.`,
    bannerImg: ManualTestingBannerImg,
    mainBanner: ManualTestingMainBannerImg,
    bannerTitle: "In-Depth Manual Testing for Flawless Performance",
    bannerDiscriptions: [
      `Our team of experienced test engineers and developers leverage their knowledge to
       check and validate your application for bugs and defects to smoothen your development.`,
      ``,
    ],
  },

  // service detail page content for automation  testing
  {
    serviceId: 11,
    label: "your Automation Testing is Our Passion",
    title: "Automation Testing",
    titleImg: AutomationTestingTitleImg,
    subtitle: "Harnessing Technology for Rapid Test Automation",
    titleDiscription: `We automate and put your testing process on auto-pilot, however,
we monitor and receive frequent and consistent test reports that benchmarks
your system performance.Automated testing is commonly referred to as automation testing
 an emerging and dominant type of testing in the digital product testing world. automation
 testing provides tools and frameworks for testing and inspections of digital solutions.`,
    bannerImg: AutomationTestingBannerImg,
    mainBanner: AutomationTestingMainBannerImg,
    bannerTitle:
      "Explore and implement viable automated quality assurance and testing services with Vis Group",
    bannerDiscriptions: [
      `Automated testing is a great way to optimize QA resources.
       Vis Group will work with you to create a custom automation testing
       schedule, provide quick feedback on weak spots, and share ideas
       for software improvement. Thus, you’ll be able to collect meaningful
       data for the development team, accelerate software updates, and fast-track product releases.`,
    ],
  },

  // service detail page content for performance   testing
  {
    serviceId: 12,
    label: "your Performance Testing is Our Passion",
    title: "Performance Testing",
    titleImg: PerformanceTestingTitleImg,
    subtitle: "Benchmark Your Way to Superior Performance",
    titleDiscription:
      "Every mobile network operator throughout the world invests a huge amount of resources in terms of time and cost to improve and enhance their service quality. Network benchmarking helps network providers, to evaluate their network performance against their competitors in the market. With a constant demand for new services and better network performance, it is critical that operators have a reliable, accurate, and reproducible way to measure the services provided to their customers and compare themselves against other operators. Our comprehensive benchmarking reports can be used to analyze their performance, identify their weakness, and take measurements to improve furthermore.",
    bannerImg: PerformanceTestingBannerImg,
    mainBanner: PerformanceTestingMainBannerImg,
    bannerTitle: "Unveiling Network Strengths, One Test at a Time.",
    bannerDiscriptions: [
      "Performance Testing is a fundamental necessity for telecom regulators and operators. Regulators have to conduct drive testing in order to monitor the quality of service standards against the KPIs agreed on with the operators, and operators undergo benchmarking activity to do exhaustive analysis, to remain competitive. It is also an effective way of getting to know the competition and gathering valuable information as a source for focused promotional campaigns.We offer among other services, a complete set of network benchmarking services through Field-Testing (Drive and Walk Tests). Drive test is performed in cities, towns, and on roads, while walk test is performed in public areas like airports, shopping malls, etc. For every area, we have weighted scores which will be added to calculate the total score for each operator. As per customer requirements, key performance indicators (KPIs) are decided within the project scope, which determines the team configuration and size. To achieve the desired results and to identify the loopholes in the service quality our Professionals Field Engineers collect the data, which is then analyzed by our radio network experts and presented to the customer in the form of reports against their KPIs.We have successfully performed different drive and walk tests campaigns for various clients in the whole EU, in countries such as Germany, the Netherlands, Sweden, Italy, France, the UK, UAE, Kuwait, the Kingdom of Saudi Arabia, Qatar, and many more. We use the latest mobile devices, high-end drive test tools, and RF scanners for measurements around the globe.",
      "Performance Testing is a fundamental necessity for telecom regulators and operators. Regulators have to conduct drive testing in order to monitor the quality of service standards against the KPIs agreed on with the operators, and operators undergo benchmarking activity to do exhaustive analysis, to remain competitive. It is also an effective way of getting to know the competition and gathering valuable information as a source for focused promotional campaigns.We offer among other services, a complete set of network benchmarking services through Field-Testing (Drive and Walk Tests). Drive test is performed in cities, towns, and on roads, while walk test is performed in public areas like airports, shopping malls, etc. For every area, we have weighted scores which will be added to calculate the total score for each operator. As per customer requirements, key performance indicators (KPIs) are decided within the project scope, which determines the team configuration and size. To achieve the desired results and to identify the loopholes in the service quality our Professionals Field Engineers collect the data, which is then analyzed by our radio network experts and presented to the customer in the form of reports against their KPIs.We have successfully performed different drive and walk tests campaigns for various clients in the whole EU, in countries such as Germany, the Netherlands, Sweden, Italy, France, the UK, UAE, Kuwait, the Kingdom of Saudi Arabia, Qatar, and many more. We use the latest mobile devices, high-end drive test tools, and RF scanners for measurements around the globe.",
    ],
  },

  // service detail page content for API  testing
  {
    serviceId: 13,
    label: "your API Testing is Our Passion",
    title: "API Testing",
    titleImg: ApiTestingTitleImg,
    subtitle: "Seamless Integration and Reliability in Every API Call",
    titleDiscription: `API Testing ensures that APIs, which are the building blocks of 
      modern software, function seamlessly and reliably. Given
      the critical role APIs play in enabling communication between
      software components, it is essential to conduct thorough testing
       to ensure they perform correctly under all conditions. API testing
       involves validating the functionality, reliability, performance,
       and security of APIs, providing a robust framework for detecting
        and fixing issues before they impact end-users.
        Our API testing services focus on ensuring that APIs deliver expected
         results consistently and can handle various load conditions without
          compromising performance. We provide extensive testing solutions,
           including functional testing to verify that the APIs perform as
            intended, load testing to evaluate their performance under
             stress, and security testing to protect
             against potential vulnerabilities.`,
    bannerImg: ApiTestingBannerImg,
    mainBanner: ApiTestingMainBannerImg,
    bannerTitle:
      "Optimize, Secure, and Validate Your APIs for Superior Performance",
    bannerDiscriptions: [
      `By conducting integration testing, we ensure that APIs interact seamlessly
       with other systems, maintaining data integrity and interoperability.In
       a rapidly evolving technological landscape, compliance with industry
        standards and regulations is paramount. Our compliance testing
        services ensure that your APIs meet all necessary legal and
        regulatory requirements, giving you peace of mind and ensuring
        your solutions are market-ready. By leveraging our API testing
         expertise, you can enhance the quality, security, and reliability
          of your software, delivering superior performance and user satisfaction.`,
    ],
  },

  // OFC section:
];

export const tags = [
  // sub services tags for the network benchmark testing
  {
    serviceId: 1,
    details: [
      {
        title: "Performance Benchmarking",
        icon: PerformanceBenchmarkingIcon,
        desc: `Performance benchmarking to evaluate network speed,
       reliability, and efficiency. Our thorough assessments identify
        areas for improvement, ensuring optimal performance.
        Trust us to enhance your network’s capabilities
        and deliver exceptional results`,
      },
      {
        title: "Quality of Service (QoS) Testing",
        icon: QualityofServiceQoSTestingIcon,
        desc: `Quality of Service (QoS) testing to evaluate network performance 
        under various conditions. Our comprehensive tests identify potential issues,
        ensuring consistent and reliable service. Enhance your network’s quality
         and user satisfaction with our expert assessments`,
      },
      {
        title: "Latency Testing",
        icon: LatencyTestingIcon,
        desc: `Latency testing to evaluate the responsiveness of networks.
         Our detailed assessments identify delays and optimize performance.
         Enhance your network’s responsiveness and efficiency
          with our expert testing services`,
      },

      {
        title: "Throughput Testing",
        icon: ThroughputTestingIcon,
        desc: `Throughput testing determines the maximum data transfer rate of networks. 
        Evaluations identify peak performance thresholds, ensuring optimal data handling.
         Enhance network efficiency with comprehensive throughput assessments`,
      },

      {
        title: "Coverage Testing",
        icon: CoverageTestingIcon,
        desc: `Coverage testing to assess network reach and signal strength in 
        various locations. Our evaluations identify weak spots and optimize signal
         distribution. Enhance your network’s reach and reliability with 
         comprehensive coverage assessments`,
      },

      {
        title: "Comparative Analysis ",
        icon: ComparativeAnalysisIcon,
        desc: `Comparative analysis and reporting to identify areas for improvement 
        and optimization. Our detailed reports highlight performance gaps and provide
        actionable insights. Drive your network's efficiency
         and effectiveness with detailed expert analysis.`,
      },
    ],
  },

  // sub services tags for field performnace testing
  {
    serviceId: 2,
    details: [
      {
        title: "Stationary Testing",
        icon: StationaryTestingIcon,
        desc: `Stationary test-cases are executed in defined locations to ensure that the 
        mobile device behaves according to operator and country specifications.
         By conducting tests in fixed positions, we can accurately measure signal
         strength, data speeds, and connectivity stability. This method helps
         identify any performance issues or compliance gaps, ensuring that the
         network meets regulatory standards. Our thorough stationary testing provides
          reliable data to support network optimization and enhance overall
          user experience in specific areas`,
      },
      {
        title: "Mobility Testing",
        icon: MobilityTestingIcon,
        desc: `Mobility test-cases are run in mobile testing vehicules. Mobility 
        testing covers different network protocols. It measures the device's data
         download and upload capabilities, the call functionality and the success
          rate, on a predefined route. Handovers, performances in weak fiel conditions,
          as well as in varying strengths, are also tested within the scope on mobility testing.`,
      },
      {
        title: "Walk Test",
        icon: WalkTestIcon,
        desc: `Walk Testing evaluates network performance in indoor environments such as 
        shopping malls, airports, and other public spaces. This service ensures consistent
         quality and coverage in high-density areas where seamless connectivity is crucial.
          By analyzing signal strength, data throughput, and user experience in
          these locations, we help identify and resolve coverage gaps and performance
           issues. Our comprehensive walk tests provide valuable insights to optimize
            network performance and enhance customer satisfaction in indoor settings`,
      },
      // {
      //   title: "KPI Analysis",
      //   icon: GifBoxIcon,
      //   desc: `Our KPI Analysis service defines and measures critical performance indicators
      //    based on your specific requirements. We analyze the collected data to provide actionable
      //     insights, enhancing network quality and user satisfaction. By focusing on key metrics
      //     such as call drop rates, data speeds, and latency, we help you understand the current
      //      performance and identify areas for improvement. Our detailed analysis ensures that
      //       your network meets industry standards and exceeds customer expectations.
      //       This proactive approach enables you to make informed decisions and
      //       implement strategies that drive continuous network enhancement`,
      // },
    ],
  },

  // sub services tags for the global certification forum
  {
    serviceId: 3,
    details: [
      {
        title: "Device Certification Framework",
        icon: DeviceCertificationFrameworkIcon,
        desc: `The Global Certification Forum (GCF) provides a certified framework
         for devices integrating cellular technologies such as GERAN (GSM),
         UTRAN (UMTS), and E-UTRAN (LTE). This certification ensures that
          devices operate seamlessly within global frequency bands, including
          GSM 900/1800, FDD I, and FDD VIII. By adhering to GCF standards,
          manufacturers can guarantee that their devices meet international
           performance and interoperability requirements, facilitating smooth
           operation across diverse network environments worldwid`,
      },

      {
        title: "Comprehensive Device Coverage",
        icon: ComprehensiveDeviceCoverageIcon,
        desc: `GCF Certification applies to a broad spectrum of devices, from net-books
         and consumer electronics to smart meters, handsets, PDAs, smartphones, and USB
          modules. Any device with integrated 3GPP modules stands to benefit from this
           certification. GCF Certification provides assurance of quality and performance,
            making it a valuable asset for devices aiming to succeed in competitive
             markets. This wide applicability ensures that a variety of devices
             can achieve optimal performance and reliability.`,
      },

      {
        title: "Network Operator Assurance",
        icon: NetworkOperatorAssuranceIcon,
        desc: `For network operators, GCF Certification provides a crucial assurance that
         new devices will perform well within their networks. Testing each new device
          for conformance and interoperability is impractical, so operators rely on
           GCF Certification to ensure that core functionalities meet their requirements.
            This certification is particularly advantageous when selling devices to
            operators or retailers, especially in Europe and Asia, as it signals
            that the device has been rigorously tested and approved`,
      },

      {
        title: "Certification Assistance",
        icon: CertificationAssistanceIcon,
        desc: `We assist manufacturers throughout the GCF Certification process,
         leveraging our expertise and collaboration with authorized partners.
          We help develop comprehensive test cases that cover all essential
           functionalities of the device. This support ensures that manufacturers
           can navigate the certification process efficiently and effectively,
           enhancing their ability to bring certified devices to market.`,
      },

      {
        title: "Field and Interoperability Testing",
        icon: FieldandInteroperabilityTestingIcon,
        desc: `Field Testing and Interoperability Testing are critical components 
        of the GCF Certification process. Our team conducts these tests to verify
        that the device performs well in real-world conditions and interacts seamlessly
         with other network elements. The results of these tests are meticulously
          documented and submitted for review. This thorough testing process helps
           to identify and resolve potential issues, ensuring that the device
           meets all necessary standards and is ready for certification`,
      },
    ],
  },

  // sub services tags for the SOS emergency calls testing
  {
    serviceId: 4,
    details: [
      {
        title: "Functional Testing",
        icon: FunctionalTestingIcon,
        desc: `Our functional testing verifies the entire call process, ensuring correct
         routing to emergency services. We assess voice quality for clear communication
         of emergency information and perform redundancy and failover testing to ensure
          backup systems activate seamlessly if the primary system fails, guaranteeing
          continuous service.`,
      },

      {
        title: "Performance Testing",
        icon: PerformanceTestIcon,
        desc: ` Performance testing includes load testing to simulate high call volumes
         and ensure the system handles peak loads without performance degradation.
         We perform stress testing to identify breaking points and ensure the system
          can recover gracefully. Additionally, we measure response times to ensure
          prompt call connections and responses by emergency services.`,
      },
      {
        title: "Compliance Testing",
        icon: ComplianceTestingIcon,
        desc: `Compliance testing ensures the emergency call system adheres to local,
         national, and international regulations and standards. We also perform accessibility
          testing to verify that the system is accessible to all users, including those with
           disabilities, in compliance with regulatory requirements.`,
      },
    ],
  },

  // sub services tags for the GPS testing
  {
    serviceId: 5,
    details: [
      {
        title: "Parameter Evaluation",
        icon: ParameterEvaluationIcon,
        desc: `Evaluating the fundamental performance parameters of GPS receivers is crucial 
        to ensuring their reliability and accuracy. Our team of test engineers focuses on
         critical parameters such as sensitivity, time to first fix, and reacquisition time.
          By meticulously assessing these aspects, we help manufacturers understand the
          performance capabilities of their GPS systems. This thorough evaluation enables
           manufacturers to make necessary adjustments and improvements, ensuring their
            GPS receivers meet the highest standards of quality and performance`,
      },

      {
        title: "Feature Testing",
        icon: FeatureTestingIcon,
        desc: `Modern GPS navigators offer a multitude of features beyond basic navigation. 
        Our testing services include verifying the functionality of advanced features such
        as alternative routes, route redirection, and toll avoidance. We ensure that these
        features operate smoothly and provide accurate information to users. By rigorously
         testing these functionalities, we help manufacturers deliver GPS systems that
          not only navigate effectively but also enhance the overall driving experience
          with useful, reliable features.`,
      },
      {
        title: "Signal Reception Testing",
        icon: SignalReceptionTestingIcon,
        desc: `A GPS receiver's ability to capture and process signals from 
        satellites is fundamental to its performance. Our signal reception
         testing services ensure that GPS receivers maintain strong and consistent
         communication with satellites, even in challenging environments. We assess
          the receiver’s capability to handle weak signals, interference, and
           other real-world conditions. This testing helps manufacturers
           guarantee that their GPS systems provide reliable navigation and
            positioning information under various conditions`,
      },
      {
        title: "System Integration Testing",
        icon: SystemIntegrationTestingIcon,
        desc: `GPS receivers often need to communicate and integrate seamlessly
         with other connected systems in a vehicle or device. Our system integration
        testing services verify that GPS receivers work harmoniously with other
        onboard systems, ensuring smooth data exchange and functionality.
        We check for any potential conflicts or issues that might arise during
        integration, helping manufacturers deliver GPS systems that
        function flawlessly within a larger network of connected technologies.`,
      },

      {
        title: "Error Detection and Rectification",
        icon: ErrorDetectionAndRectificationIcon,
        desc: `Identifying and rectifying errors in GPS systems is essential
         to providing users with a reliable and satisfying experience. Our team
          conducts comprehensive tests to uncover any flaws or issues in the GPS
          receiver’s performance. Once identified, we work with manufacturers
           to rectify these errors, improving the overall quality and
            reliability of the GPS system. This proactive approach
            ensures that end-users receive a product that performs
             exceptionally well and meets their navigation needs.`,
      },

      {
        title: "Environmental Testing",
        icon: EnvironmentalTestingIcon,
        desc: `GPS performance can be affected by various environmental conditions,
        such as urban canyons, dense forests, and adverse weather. Our environmental
         testing services evaluate how GPS receivers perform under these
          challenging conditions. By simulating different environments,
          we ensure that GPS systems can maintain accuracy and reliability
           regardless of external factors. This testing helps manufacturers
            create robust GPS solutions that provide consistent
             performance in diverse scenarios.`,
      },
    ],
  },

  // sub services tags for Tuner and media Testing
  {
    serviceId: 6,
    details: [
      {
        title: "Broadcast Standards Testing",
        icon: BroadcastStandardsTestingIcon,
        desc: `Our broadcast standards testing services ensure that automotive
         infotainment systems comply with all relevant analog and digital
         broadcasting standards, including AM, FM, DAB, and DRM. By thoroughly
          evaluating the performance of car radio broadcasting and audio/video
           streaming capabilities, we help manufacturers deliver systems that
            meet regulatory requirements and provide superior user experiences.
            This testing covers a wide range of broadcast formats, ensuring
             comprehensive compliance and functionality.`,
      },
      {
        title: "Connectivity and Network Testing",
        icon: ConnectivityandNetworkTestingIcon,
        desc: `In today’s interconnected world, automotive infotainment systems
         must support various connectivity options. Our testing services include
          compliance testing for wireless interfaces such as Wi-Fi, Bluetooth®,
           and LTE, as well as wired interfaces like HDMI and Ethernet.
           We ensure that these systems can handle multiple types of
            network connections seamlessly, providing reliable
            performance for streaming, navigation, and other
            connected services. This testing guarantees that infotainment
             systems remain robust and functional
             in diverse connectivity environments.`,
      },
      {
        title: "Audio System Testing",
        icon: AudioSystemTestingIcon,
        desc: `A critical component of any automotive infotainment system 
        is its audio setup. Our audio system testing services evaluate the
         performance and quality of audio speakers within the vehicle. By
         testing different audio setups and configurations, we help
         manufacturers optimize sound quality and ensure consistent
          audio performance. This comprehensive testing covers various audio
          file formats and codecs, ensuring that the system can handle
           diverse media inputs effectively.`,
      },
    ],
  },

  // sub services tags for human machine interface(HMI) testing
  {
    serviceId: 7,
    details: [
      {
        title: "Functionality Testing",
        icon: FunctionalityTestingIcon,
        desc: `Functionality testing is crucial to ensure that all components of the HMI
         system, from basic controls to complex infotainment features, work seamlessly
         together. We rigorously test each function and feature to identify any issues
         and ensure consistent performance across different operational scenarios.
          By verifying functionality, we help manufacturers deliver HMI systems
          that meet high standards of performance and reliability.`,
      },
      {
        title: "Usability and User Experience ",
        icon: UsabilityAndUserExperienceIcon,
        desc: `User interfaces in vehicles must be intuitive, easy to navigate, and accessible 
        to all users. Our usability and user experience testing services evaluate HMI
        interfaces for usability across different demographics and driving conditions.
         We assess interface design, interaction flow, and accessibility features to
          enhance user satisfaction and ensure a positive driving experience.
           By optimizing usability, manufacturers can differentiate their
           products and gain a competitive edge in the market.`,
      },
      {
        title: "Integration Testing",
        icon: IntegrationTestingIcon,
        desc: `HMI systems in vehicles interact with numerous other systems and applications,
         such as navigation, entertainment, and vehicle diagnostics.
          Our integration testing services verify that these systems integrate
          seamlessly, ensuring smooth data exchange and operation. We identify
           and address compatibility issues to minimize disruptions and
           optimize overall system performance. This comprehensive
            testing approach helps manufacturers deliver interconnected
             HMI solutions that enhance vehicle functionality and user convenience.`,
      },

      {
        title: "Localization Testing",
        icon: LocalizationTestingIcon,
        desc: `Adapting HMI interfaces for different global markets requires careful 
        consideration of cultural preferences, language nuances, and regulatory
         requirements. Our localization testing services ensure that HMI
         interfaces are culturally appropriate and linguistically
         accurate for diverse markets. We test interface translations,
         cultural references, and localized content to ensure clarity
          and usability. By addressing localization challenges proactively,
           manufacturers can expand their market reach and deliver tailored
           HMI solutions that resonate with international audiences.`,
      },

      {
        title: "Safety and Compliance Testing",
        icon: SafetyAndComplianceTestingIcon,
        desc: `Safety is paramount in automotive HMI systems. Our safety and
         compliance testing services verify that HMI interfaces meet industry
         safety standards and regulatory requirements. We assess system
         reliability, response times, and fail-safe mechanisms to ensure
         safe operation during driving. By conducting rigorous safety
         testing, we help manufacturers mitigate risks and build trust
          with users by delivering HMI systems that prioritize safety and security.`,
      },

      {
        title: "Performance Optimization",
        icon: PerformanceOptimizationIcon,
        desc: `Optimizing HMI performance is essential to deliver responsive and
         reliable user interfaces. Our performance optimization services focus
          on enhancing system responsiveness, reducing latency, and improving
           overall efficiency. We conduct performance testing under various
            load conditions to identify bottlenecks and optimize resource
             utilization. By improving performance, manufacturers can
              provide users with smooth and seamless interactions,
              enhancing the overall driving experience.`,
      },
    ],
  },

  // sub services tags for Web Application development
  {
    serviceId: 8,
    details: [
      {
        title: "Custom Web Development",
        icon: CustomWebDevelopmentIcon,
        desc: `We brainstorm, ideate, and execute custom-based web applications 
        tailored to our clients-specific needs. Our emphasis on code quality
         and security during the development process results in enhanced
         user experience and satisfaction.`,
      },

      {
        title: "Progressive Web Development",
        icon: ProgressiveWebDevelopmentIcon,
        desc: `Our customer-centric approach enables us to develop cross-platform
         PWA,s. Thanks to the pool of our experienced developers that ensure
         better performance and user experience in PWAs development.`,
      },

      {
        title: "Full Stack Web Development",
        icon: FullStackWebDevelopmentIcon,
        desc: `Our Web application Development team consist of developers and
         designers having experience in a diverse range of web development
          technologies. This enables them to carry out full-stack development
           on MERN, MEAN, PHP, .Net and JavaScript.`,
      },
    ],
  },

  // sub services tags for mobile App Development
  {
    serviceId: 9,
    details: [
      {
        title: "Android Apps",
        icon: AndroidAppsIcon,
        desc: `We develop robust, scalable, and dynamic Android Apps using different
         tools and frameworks, which not only fulfill your business requirement;
         but strictly adhere to Google guidelines and regulations.`,
      },

      {
        title: "IoS Apps",
        icon: IosappIcon,
        desc: `We develop Apps targeting the iOS platform using swift 
        and objective-C programming languages, which provide a
        seamless user experience on Apple devices.`,
      },

      {
        title: "Cross Platform Apps",
        icon: CrossPlatformAppsIcon,
        desc: `Due to the availability of multiple platforms, we leverage
         our experience to deliver top niche cross-platform applications
         using HTML, JavaScript and react native framework.`,
      },
    ],
  },

  // sub services tags for Manual Testing
  {
    serviceId: 10,
    details: [
      {
        title: "Functional Testing",
        icon: FunctionalIcon,
        desc: `Functional testing ensures that each function of the software behaves as
         expected according to specified requirements. Our team conducts comprehensive
          tests to validate functionalities from an end-user perspective,
          identifying and reporting bugs to improve overall software quality.
           By focusing on functional correctness, we help developers
            deliver reliable and user-friendly
            applications that meet customer expectations.`,
      },
      {
        title: "Regression Testing",
        icon: RegressionTestingIcon,
        desc: `Regression testing verifies that previously functioning features
         still work correctly. Our regression testing services ensure that
         new code modifications do not introduce unintended issues or regressions.
          By re-testing critical functionalities, we maintain software
           integrity and prevent potential bugs from affecting the user experience.
           This proactive approach minimizes risks and enhances software stability over time.`,
      },
      {
        title: "Usability Testing",
        icon: UsabilityTestingIcon,
        desc: `Usability testing evaluates how easily and intuitively users
         can interact with the software. Our testing methodology includes
         gathering feedback from end-users to assess navigation, task
         completion, and overall user satisfaction. By focusing on usability,
          we identify usability issues, streamline workflows, and improve
          user interface design. This testing ensures that software
           applications are user-friendly,
           enhancing adoption rates and user engagement.`,
      },
    ],
  },

  // Sub Service tags for automation testing
  {
    serviceId: 11,
    details: [
      {
        title: "Performance and Load Testing ",
        icon: PerformanceAndLoadTestingAutomationIcon,
        desc: `Automated performance and load testing simulates various
         user loads and system conditions to assess software scalability
         and performance under stress. Our automation tools and methodologies
          allow for comprehensive testing of application responsiveness, stability,
           and resource utilization. By automating performance tests, we provide
           actionable insights into system bottlenecks and performance
           optimization opportunities, enabling you to deliver
           high-performing software solutions.`,
      },
      {
        title: "Mobile App Automation Testing ",
        icon: MobileApplicationTestingAutomationIcon,
        desc: `Automation of mobile application testing ensures consistent 
        functionality and performance across various mobile devices
        and platforms. We automate tests for mobile apps to validate
        usability, responsiveness, and compatibility with different
         operating systems and device specifications. By leveraging
          automated testing tools and frameworks, we help streamline
           mobile app testing processes, accelerate release cycles,
            and deliver high-quality mobile experiences to end-users.`,
      },
      {
        title: "Cross-Browser Automation",
        icon: CrossBrowserTestingAutomationIcon,
        desc: `Cross-browser and cross-platform testing automation verifies
         software compatibility and functionality across diverse browsers
          and operating systems. We automate tests to ensure consistent
           user experiences and performance across different environments,
            minimizing compatibility issues and enhancing customer satisfaction.
             Our automation solutions enable efficient testing across
              multiple configurations, speeding up testing cycles and
               supporting broad market reach.`,
      },
    ],
  },

  // sub services tags for performance testing
  {
    serviceId: 12,
    details: [
      {
        title: "Performance Benchmarking",
        icon: PerformanceBenchmarkingIcon,
        desc: `Performance benchmarking to evaluate network speed,
       reliability, and efficiency. Our thorough assessments identify
        areas for improvement, ensuring optimal performance.
        Trust us to enhance your network’s capabilities
        and deliver exceptional results`,
      },
    ],
  },

  // sub service tags for the API Testing
  {
    serviceId: 13,
    details: [
      {
        title: "API Testing Automation",
        icon: ApiTestingAutomationIcon,
        desc: `API testing automation validates the functionality, reliability,
         and security of APIs by automating test scenarios that verify data
          communication between different software components. Our automated
           API testing services ensure seamless integration and interaction
           between APIs, identifying potential issues early in the
            development process. By automating API tests, we enhance
            software interoperability, accelerate integration testing,
             and improve overall system reliability.`,
      },

      {
        title: "Functional Testing",
        icon: FunctionalTestIcon,
        desc: `Functional testing ensures that your APIs perform as intended 
        by validating responses for a wide range of input conditions.
        Our team designs and executes test cases to cover all possible
         API requests and responses, ensuring that the API behaves
         correctly and meets specified requirements. By identifying
          functional issues early, we help you deliver reliable
          and high-quality API services.`,
      },
      {
        title: "Security Testing",
        icon: SecurityTestingIcon,
        desc: `Security testing focuses on identifying and mitigating 
        vulnerabilities in your APIs to protect against potential
         threats and unauthorized access. We conduct thorough
         security assessments, including penetration testing
          and vulnerability scanning, to ensure your APIs are secure.
           By addressing security risks, we help safeguard sensitive
           data and maintain the integrity of your API services`,
      },
    ],
  },
];
